import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./style.css";
import "../../../../../index.css";
class SubjectRankSearch extends Component {
  render() {
    return (
      <div className="subjectRankSearch_box">
        <div className="subjectRankSearch_box_div">
          <div className="subjectRankSearch_box_div_img fl">
            <img
              alt=""
              src={require("../../../../../images/search/search_2.png")}
            ></img>
          </div>
          <div className="subjectRankSearch_box_div_input fl">
            <input
              onClick={this.handleVisibleSearch}
              placeholder="搜索或选择下面的大类"
              value=""
              readOnly
            ></input>
          </div>
        </div>
      </div>
    );
  }
  handleVisibleSearch = () => {
    this.props.history.push("/rank/subject/search");
  };
}

export default withRouter(SubjectRankSearch);



// WEBPACK FOOTER //
// ./src/containers/Rank/SubjectRank/components/SubjectRankSearch/index.js